<template>
    <el-drawer
        title="基础信息审核详情"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
        v-loading="dataLoading"
    >
        <div class="drawer-content">
            <table v-if="data" class="info-table" width="100%">
                <tr>
                    <th>头像/logo:</th>
                    <td>
                        <el-image
                            :src="data.auditContent.avatar"
                            fit="cover"
                            class="avatar"
                            :preview-src-list="[...data.auditContent.avatar]"
                        ></el-image>
                    </td>
                </tr>
                <tr>
                    <th>名称:</th>
                    <td>{{ data.auditContent.name }}</td>
                </tr>
                <tr>
                    <th>角色:</th>
                    <td>
                        <span v-if="data.auditContent.userType == 2">艺人</span>
                        <span v-if="data.auditContent.userType == 3">场地</span>
                        <span v-if="data.auditContent.userType == 5">厂牌</span>
                    </td>
                </tr>
                <tr>
                    <th>所在城市:</th>
                    <td>{{ data.auditContent.cityName }}</td>
                </tr>
                <template v-if="data.auditContent.userType == 2">
                    <tr>
                        <th>形式:</th>
                        <td>
                            {{
                                data.auditContent.userForm == 1
                                    ? "个人"
                                    : "团体"
                            }}
                        </td>
                    </tr>
                    <tr v-if="data.auditContent.userForm == 2">
                        <th>组建时间:</th>
                        <td>{{ data.auditContent.birthday }}</td>
                    </tr>
                    <tr>
                        <th>成员人数:</th>
                        <td>{{ data.auditContent.numberPeople || data.auditContent.memberCount }}</td>
                    </tr>
                    <tr>
                        <th>风格:</th>
                        <!-- <td>{{ data.auditContent.styleTags }}</td> -->
                        <td>{{data.auditContent.tags.filter(v => v.styleId != 22).map(item => item.styleName+(item.tagName ? '-'+item.tagName : '')).toString()}}</td>
                    </tr>
                    <tr>
                        <th>主风格:</th>
                        <td>{{ mainStyleName }}</td>
                    </tr>
					<tr v-if="data && data.auditContent.neteaseCloudKey">
					    <th width="130">网易云音乐艺人ID:</th>					    
					    <td>{{data.auditContent.neteaseCloudKey}}</td>
					</tr>
                </template>
                <template v-if="data.auditContent.userType == 3">
                    <tr>
                        <th>地址:</th>
                        <td>{{ data.auditContent.address }}</td>
                    </tr>
                    <tr>
                        <th>咨询电话:</th>
                        <td>{{ data.auditContent.hotline || data.auditContent.contact }}</td>
                    </tr>
                    <tr>
                        <th>容纳人数:</th>
                        <td>{{ data.auditContent.legalCapacity || data.auditContent.capacity}}</td>
                    </tr>
                </template>
                <template v-if="data.auditContent.userType == 5">
                    <tr>
                        <th>旗下艺人:</th>
                        <td>
                            <template
                                v-for="(item, index) in data.auditContent
                                    .performers"
                            >
                                <span :key="index">{{ item.name }}</span>
                                <template
                                    v-if="
                                        index <
                                        data.auditContent.performers.length -
                                            1
                                    "
                                    > ， </template
                                >
                            </template>
                        </td>
                    </tr>
                </template>
                <tr>
                    <th>小站:</th>
                    <td><el-link :href="data.auditContent.siteLink" target="_blank">{{data.auditContent.siteLink}}</el-link></td>
                </tr>
                <tr>
                    <th>简介:</th>
                    <td><div class="description">{{ data.auditContent.description || data.auditContent.desc }}</div></td>
                </tr>
                <tr v-if="data.auditContent.poster">
                    <th width="80">背景图:</th>
                    <td>
                        <el-image
                            :src="data.auditContent.poster"
                            fit="cover"
                            :preview-src-list="[...data.auditContent.poster]"
                            class="backgroundImage"
                        ></el-image>
                    </td>
                </tr>
				<tr v-if="data.auditContent.qrCodeAddress">
				    <th width="100">粉丝群二维码:</th>
				    <td>
				        <el-image
				            :src="data.auditContent.qrCodeAddress"
				            fit="cover"
				            :preview-src-list="[...data.auditContent.qrCodeAddress]"
				            class="qrCodeAddress"
				        ></el-image>
				    </td>
				</tr>
            </table>
        </div>
        <div v-if="data" class="drawer-footer">
            <template v-if="data.auditStatus == 1 && $utils.have('/baseInfoAudit/operation')">
                <el-button
                    type="success"
                    @click="auditEvent(2)"
                    :loading="btnLoading"
                    >通过</el-button
                >
                <el-button
                    type="warning"
                    @click="auditEvent(3)"
                    :loading="btnLoading"
                    >拒绝</el-button
                >
            </template>
            <el-tag v-if="data.auditStatus == 2" type="success">已通过</el-tag>
            <el-tag v-if="data.auditStatus == 3" type="info">已拒绝</el-tag>
        </div>
    </el-drawer>
</template>

<script>
import baseData from '@/assets/js/baseData';

export default {
    data() {
        return {
            drawerShow: false,
            dataLoading: false,
            btnLoading: false,
            id: "",
            data: null,
        };
    },
    computed: {
        mainStyleName() {
            if (!this.data || !this.data.auditContent || !this.data.auditContent.mainStyleId) {
                return '无';
            }
            const item = baseData.mainStyle.find(v => v.value === this.data.auditContent.mainStyleId);
            return item ? item.name : '-';
        }
    },
    methods: {
        close() {
            this.drawerShow = false;
        },
        async show(id) {
            this.id = id;
            await this.getDataDetail();
            this.drawerShow = true;
        },
        //获取详情
        getDataDetail() {
            this.dataLoading = true;
            this.$request({
                url: "/baseInfoAudit/detail",
                data: { auditId: this.id },
                method: "post",
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1) {
                        this.data = result;
                        let siteLink = `${process.env.VUE_APP_SSWEB_URL}`;
                        const {userType,id} = this.data.auditContent;
                        if( userType == 2 ){
                            siteLink += `/artist/`;
                        }
                        if( userType == 3 ){
                            siteLink += `/venue/`;
                        }
                        if( userType == 5 ){
                            siteLink += `/host/`;
                        }
                        siteLink += `${id}`;
                        this.data.auditContent.siteLink = siteLink;

                    } else {
                        self.$message.error(msg || "获取信息失败,请重试");
                    }
                })
                .catch(() => {
                    self.$message.error("获取信息失败,请重试");
                })
                .finally(() => {
                    this.dataLoading = false;
                });
        },
        //审核
        auditEvent(status) {
            const _msg = status === 2 ? '确定要通过审核吗?' : '确定拒绝通过审核吗?';
            this.$confirm(_msg, '提示', {
                    type: 'warning',
                    center: true,
                    closeOnClickModal: false
                }).then(() => {
                    this.btnLoading = true;
                    this.$request({
                        url: '/baseInfoAudit/operation',
                        data: {auditId: this.id,auditStatus:status},
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit('onSuccess');
                                this.close();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }).catch(() => {})
            
        }
    },
};
</script>

<style lang="scss" scoped>
.avatar,.qrCodeAddress{
    width: 80px;
    height: 80px;
}
.backgroundImage,.description{
    max-width: 360px;
}

</style>